import http from './plugin/ajax'

const IMAGE_HOST = 'http://xcx.ooomi.com'

export const resolveImageUrl = (path) => {
  if (!path) return ''
  if (/^https?:\/\//.test(path)) return path
  if (typeof path === 'string' && path.startsWith('data:')) return path
  return `${IMAGE_HOST}${path.startsWith('/') ? '' : '/'}${path}`
}

// 查询 账号列表
export const rqIndexUserList  = (data) => http.get('/auth/user/exchange',data)

// 后台登录
export const rqLogin = (data) => http.post('/auth/login', data)

// 退出登录
export const rqLogout = () => http.post('/auth/logout')

// 修改登录密码（需二级密码）
export const rqModifyUserPassword = (data) => http.post('/auth/userPassword', data)

// 校验二级密码
export const rqVerifySecondaryPassword = (data) => http.post('/auth/verifySecondaryPassword', data)

// 平台数据总览（旧漏斗口径，兼容保留）
export const rqIndexDataView = () => http.get('/index/indexDataView')

// 经营看板总览（时段 + 环比）
export const rqBusinessOverview = (range = 'TODAY') =>
  http.get('/index/businessOverview', { params: { range } })

// 审核列表
export const rqSearchApproveList = (data) => http.post('/photo/searchApproveList', data)

// 审核详情
export const rqSearchPhotoApproveDetail = (data) => http.post('/photo/searchPhotoApproveDetail', data)

// 审批作品（approveStatus: 1通过 2拒绝）— 审核已非主流程
export const rqApproveUserPhoto = (data) => http.post('/photo/approveUserPhoto', data)

// 订单列表
export const rqSearchUserOrderCart = (data) => http.post('/shoppingCart/searchUserOrderCart', data)

// 订单详情
export const rqSearchUserOrderCartDetail = (data) => http.post('/shoppingCart/searchUserOrderCartDetail', data)

// 订单生产进度（refresh: true 时回源工厂同步）
export const rqSearchOrderProductionProgress = (data) => http.post('/shoppingCart/searchOrderProductionProgress', data)

// 订单物流轨迹
export const rqSearchOrderTrack = (data) => http.post('/shoppingCart/searchOrderTrack', data)

// 推送订单到工厂（成功后自动上报微信发货信息）
export const rqPushUserOrderCart = (data) => http.post('/shoppingCart/pushUserOrderCart', data)

// 重报微信发货信息
export const rqRetryWxShipping = (data) => http.post('/shoppingCart/retryWxShipping', data)

// 管理员退款关单
export const rqRefundUserOrder = (data) => http.post('/shoppingCart/refundUserOrder', data)

// 虚拟发货（微信+本地）
export const rqVirtualShipUserOrder = (data) => http.post('/shoppingCart/virtualShipUserOrder', data)

// 交易保障-投诉
export const rqComplaintList = (params) => http.get('/guarantee/complaint/list', { params })
export const rqComplaintDetail = (params) => http.get('/guarantee/complaint/detail', { params })
export const rqComplaintRespond = (data) => http.post('/guarantee/complaint/respond', data)
export const rqComplaintSupplyProof = (data) => http.post('/guarantee/complaint/supplyProof', data)

// 商品列表
export const rqSearchMerchandise = (data) => http.post('/merchandiseController/searchMerchandise', data)

// 修改商品上下架/分类
export const rqModifyMerchandiseInfo = (data) => http.post('/merchandiseController/modifyMerchandiseInfo', data)

// 商品编辑回填
export const rqSearchModifyMerchandiseData = (data) => http.post('/merchandiseController/searchModifyMerchandiseData', data)

// 编辑商品
export const rqModifyMerchandise = (data) => http.post('/merchandiseController/modifyMerchandise', data)

// 选项报价列表（分页 + 筛选）
export const rqSearchOptionQuotes = (data) => http.post('/merchandiseController/searchOptionQuotes', data)

// 选项报价筛选项（尺寸 / 单双面 / 维度）
export const rqSearchOptionQuoteFilters = (data) => http.post('/merchandiseController/searchOptionQuoteFilters', data)

// 保存选项报价 { merchandiseId, rows }
export const rqSaveOptionQuotes = (data) => http.post('/merchandiseController/saveOptionQuotes', data)

// 批量设置选项报价 { merchandiseId, ids | filter, set }
export const rqBatchUpdateOptionQuotes = (data) => http.post('/merchandiseController/batchUpdateOptionQuotes', data)

// 保存包邮 / 运费 / 生产时效
export const rqSaveMerchandiseSalePolicy = (data) => http.post('/merchandiseController/saveMerchandiseSalePolicy', data)

// 上传图片
export const rqUpLoadImage = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return http.post('/file/upLoadImage', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 分类库列表
export const rqSearchMerchandiseGroup = (data) => http.post('/merchandiseGroupController/searchMerchandiseGroup', data)

// 添加分类
export const rqAddMerchandiseGroup = (data) => http.post('/merchandiseGroupController/addMerchandiseGroup', data)

// 修改分类
export const rqModifyMerchandiseGroupInfo = (data) => http.post('/merchandiseGroupController/modifyMerchandiseGroupInfo', data)

// 删除分类
export const rqRemoveGroupAndMerchandise = (data) => http.post('/merchandiseGroupController/removeGroupAndMerchandise', data)

// 首页配置（type: 1 banner, 2 金刚区）
export const rqSearchIndexConfig = (data) => http.post('/index/searchIndexConfig', data)

// 新增或修改首页配置
export const rqAddOrUpdateIndexConfig = (data) => http.put('/index/addorUpdateIndexConfig', data)

// 删除首页配置
export const rqRemoveIndexConfig = (id) => http.delete(`/index/removeIndexConfig/${id}`)

// 用户列表
export const rqUserListWithPage = (data) => http.post('/user/listWithPage', data)

// 用户详情
export const rqSearchUserDetail = (data) => http.post('/user/searchUserDetail', data)
